import { render, staticRenderFns } from "./index_enjiaaier.vue?vue&type=template&id=520cf27c&scoped=true&"
import script from "./index_enjiaaier.vue?vue&type=script&lang=js&"
export * from "./index_enjiaaier.vue?vue&type=script&lang=js&"
import style0 from "./index_enjiaaier.vue?vue&type=style&index=0&id=520cf27c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520cf27c",
  null
  
)

export default component.exports